export { default } from "./StudentWritePrompt";
